/* global angular */
( function () {
	'use strict';

	function fileService ( Upload, apiService, saveFileAs, uiModal, $q ) {
		var uploading = {
			'flag' : false
		};

		var fileFormats = [];

		function openModal ( model, successCallback, failedCallback ) {
			uiModal.open( {
				'templateUrl'  : '/templates/components/upload/upload-modal.html',
				'controller'   : 'uploadModalCtrl',
				'controllerAs' : 'vm',
				'animation'    : false,
				'keyboard'     : false,
				'windowClass'  : model.customClass,
				'resolve'      : {
					'uiUploadFileModel' : function () {
						return {
							'ctrl'           : model.controller,
							'parentScope'    : model.parentScope,
							'progressHolder' : model.progressHolder,
							'apiParams'      : model.apiParams,

							'title'           : model.modalTitle,
							'namePlaceholder' : model.titleInputPlaceholder,

							'confirmTitle' : model.confirmTitle,
							'cancelTitle'  : model.cancelTitle || 'Cancel',

							'successCallback' : successCallback,
							'failedCallback'  : failedCallback,

							'data' : model
						};
					}
				}
			} );
		}

		function uploadFile ( data ) {
			return Upload.upload( {
				'url'  : '/api/v1/files',
				'data' : data
			} );
		}

		function downloadFile ( fileId, params, filename ) {
			var config = {
				'method'       : 'GET',
				'params'       : params,
				'responseType' : 'blob'
			};

			return apiService.fileDownload( fileId, config )
				.then( function ( res ) {
					var blob = new Blob( [ res.data ],
						{ 'type' : 'application/octet-stream' }
					);

					saveFileAs( blob, filename || params.name );

					return filename;
				} );
		}

		function removeFile ( fileId, params ) {
			var config = {
				'method' : 'DELETE',
				'data'   : params,

				'headers' : {
					'Content-Type' : 'application/json'
				}
			};

			return apiService.file( fileId, config );
		}

		function getFile ( fileId, params ) {
			var config = {
				'method' : 'GET',
				'params' : params,

				'headers' : {
					'Content-Type' : 'application/json'
				}
			};

			return apiService.file( fileId, config );
		}

		function getFilesByResourceId ( resourceId ) {
			return apiService.filesByResourceId
				.query( { 'resourceId' : resourceId  } )
				.$promise;
		}

		function setFlag ( value ) {
			uploading.flag = value;
		}

		function getFlag () {
			return uploading;
		}

		function validation () {
			function formatize ( format ) {
				return '.' + format.FileFormatType;
			}

			return {
				'maxSize'     : '50mb',
				'fileFormats' : fileFormats.map( formatize ).join( ',' )
			};
		}

		function init () {
			function setFileFormats ( res ) {
				fileFormats = res;
				return fileFormats;
			}

			function returnFormat () {
				return $q( function ( resolve ) {
					resolve( fileFormats );
				} );
			}

			function fetchFormat () {
				return apiService
					.obsAllowedFileFormats
					.query( { } )
					.$promise
					.then( setFileFormats );
			}

			return ( fileFormats.length && returnFormat || fetchFormat )();
		}

		return {
			'open' : openModal,

			'upload'             : uploadFile,
			'download'           : downloadFile,
			'remove'             : removeFile,
			'get'                : getFile,
			'getAllByResourceId' : getFilesByResourceId,

			'uploading' : {
				'setFlag' : setFlag,
				'getFlag' : getFlag
			},

			'validation' : validation,

			'initialize' : init
		};
	}

	fileService.$inject = [ 'Upload', 'apiService', 'saveFileAs', '$modal', '$q' ];

	angular
		.module( 'app.components' )
		.factory( 'fileService', fileService );
} )();
